// Core hooks - ultra simplified system
export { useExtensionManager } from './useExtensionManager';
export { useActionExecutor } from './useActionExecutor';
export { useExtensionCartWatcher } from './useExtensionCartWatcher';
